import React from "react";
import { styled } from "@mui/material/styles";
import { NavButton } from "./NavSearchButton";
import { StoreShoppingBagIcon } from "../../StoreComponents/StoreShoppingBagIcon";
import { getHeaderTextColor } from "@/utils/StringUtils";
import { SiteBrandingType } from "@brandclub/common-ui/BrandclubLanding/type";

export const MobileNavButton = styled("div")<{
  siteBrandingType: SiteBrandingType;
}>(({ theme, siteBrandingType }) => ({
  height: 44,
  width: 44,
  minWidth: 44,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  img: {
    maxHeight: 23,
    maxWidth: 23,
  },
  color: getHeaderTextColor(theme, siteBrandingType),
}));

type NavButtonProps = React.ComponentProps<typeof NavButton>;
type MobileNavButtonProps = React.ComponentProps<typeof MobileNavButton>;
interface NavCartButtonProps {
  onClick?: NavButtonProps["onClick"];
  id?: NavButtonProps["id"];
  count?: number;
}

interface MobileNavCartButtonProps extends MobileNavButtonProps {
  count?: number;
}

const NavCartButton = ({ onClick, id, count }: NavCartButtonProps) => {
  return (
    <NavButton id={id} onClick={onClick}>
      <StoreShoppingBagIcon sx={{ fontSize: 25 }} count={count} />
    </NavButton>
  );
};

export const MobileNavCartButton = ({
  count,
  ...props
}: MobileNavCartButtonProps) => {
  return (
    <MobileNavButton {...props}>
      <StoreShoppingBagIcon sx={{ fontSize: 25 }} count={count} />
    </MobileNavButton>
  );
};

export default NavCartButton;
